module.exports = __webpack_public_path__ + "static/assets/efce83283de13c1579cbc09176aaba36.svg";